import React from "react";
import { Link } from "react-router-dom";
import MarketingShell from "@/components/MarketingShell";

const EASE = [0.4, 0, 0.2, 1];

export const legalStyles = {
  wrap: { maxWidth: "72ch" },
  eyebrow: { color: "#F2D589", letterSpacing: "0.28em" },
  h1: {
    fontFamily: "'Cormorant Garamond', serif",
    fontWeight: 300,
    fontSize: "var(--step-3)",
    letterSpacing: "-0.02em",
    lineHeight: 1.12,
  },
  h2: { fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: "var(--step-1)" },
  body: { color: "#C6BBA9", lineHeight: 1.8 },
  link: { color: "#FCA07A" },
};

export const EFFECTIVE = "June 2026";

export function LegalPage({ active, eyebrow, title, intro, sections, children }) {
  return (
    <MarketingShell active={active}>
      <article className="mt-4" style={legalStyles.wrap} data-testid={`legal-${active.replace("/", "")}`}>
        <p className="text-[11px] uppercase mb-4" style={legalStyles.eyebrow}>
          {eyebrow}
        </p>
        <h1 style={legalStyles.h1}>{title}</h1>
        <p className="mt-6 text-xs uppercase" style={{ color: "#6B7A82", letterSpacing: "0.2em" }}>
          In effect {EFFECTIVE}
        </p>
        {intro && (
          <p className="mt-8 text-base sm:text-lg" style={legalStyles.body}>
            {intro}
          </p>
        )}

        <div className="mt-16 flex flex-col gap-14">
          {sections.map((s, i) => (
            <section key={s.h} data-testid={`legal-section-${i + 1}`}>
              <h2 style={legalStyles.h2}>{s.h}</h2>
              <div className="mt-4 flex flex-col gap-4 text-base" style={legalStyles.body}>
                {s.p.map((para) => (
                  <p key={para.slice(0, 40)}>{para}</p>
                ))}
              </div>
            </section>
          ))}
        </div>

        {children}

        <p className="mt-20 text-sm" style={legalStyles.body}>
          Questions about any of this? Write to{" "}
          <a href="mailto:hello@danberrymusic.com" style={legalStyles.link} data-testid="legal-contact-email">
            hello@danberrymusic.com
          </a>
          .
        </p>
        <div className="mt-8 flex flex-wrap gap-8 text-xs uppercase" style={{ letterSpacing: "0.2em" }}>
          <Link to="/privacy" style={legalStyles.link} data-testid="legal-link-privacy">
            Privacy
          </Link>
          <Link to="/terms" style={legalStyles.link} data-testid="legal-link-terms">
            Terms
          </Link>
        </div>
      </article>
    </MarketingShell>
  );
}

export { EASE };
